import React from "react";
import { useTranslation } from "react-i18next";

// Matches the mockup pattern:
// Left:  "SAMM {n} / {total}" small-caps primary label
//        H1 step title (big, bold)
// Right: "Lõpetatud: {pct}%"
// Below: thin horizontal gradient progress bar (h-2) with glow
export function StepProgress({ steps, currentStep }) {
  const { t } = useTranslation();
  const total = steps.length;
  const step = steps.find((s) => s.num === currentStep) || steps[0];
  const pct = Math.round((currentStep / total) * 100);

  const stepLabel = t("dashboard.stepLabel") || "Samm";
  const completedLabel = t("dashboard.completedLabel") || "Lõpetatud";

  return (
    <div className="mb-10">
      <div className="flex justify-between items-end mb-4 gap-4">
        <div className="min-w-0 flex-1">
          <span
            className="text-xs font-semibold uppercase tracking-[0.15em]"
            style={{ color: "#00658D" }}
            data-testid="step-progress-indicator"
          >
            {stepLabel} {currentStep} / {total}
          </span>
          <h1
            className="text-3xl md:text-4xl font-bold tracking-tight mt-1 truncate"
            style={{ color: "#181c20" }}
          >
            {step.label}
          </h1>
        </div>
        <div className="text-right shrink-0 hidden sm:block">
          <span className="text-sm font-medium" style={{ color: "#3e4850" }}>
            {completedLabel}: {pct}%
          </span>
        </div>
      </div>
      <div
        className="h-2 w-full rounded-full overflow-hidden"
        style={{ background: "#ebeef3" }}
      >
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{
            width: `${pct}%`,
            background: "linear-gradient(90deg, #00aeef 0%, #00658d 100%)",
            boxShadow: "0 0 8px rgba(0,174,239,0.4)",
          }}
        />
      </div>
    </div>
  );
}
